import { isNullOrUndefined } from 'util';
import {
  ColorLibrary,
  colorFromSteps,
  colorMapsFromMinMaxFactory,
  constantStepCalculator
} from '../../utils/color-maps';

import {
  makeLegendMinMax
} from '../../utils/utils'

export default {
  sectionText: 'Social Geography',
  section: 'social_geography',
  components: [
    {
      text: 'Population',
      type: 'switch',
      stateProperty: 'population',
      layerType: 'rasterfile',
      layerConfig: {
        url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/socioeconomic/World Pop mys_ppp_2020_UNadj_clipped-cogeo.tif',
        name: 'population',
        id: 'population',
        title: 'Population (ha)',
        attributionString: 'World population',
        pixelValuesToColorFn: colorMapsFromMinMaxFactory({
          colorSteps: ['#f1eef6', '#d7b5d8', '#df65b0', '#dd1c77', '#980043'],
          min: 0,
          max: 250,
          transparentValues: [0]

        }),
        legend: makeLegendMinMax(['#f1eef6', '#d7b5d8', '#df65b0', '#dd1c77', '#980043'], 0, 250),
        opacity: 1,
        resolution: 96,
        zIndex: 420
      }
    }
  ]
}